let isOpen = false;
const scriptElement = document.currentScript;
const insuranceVariantId = scriptElement.dataset.insuranceVariantId;
const title = scriptElement.dataset.toggleTitle || 'Package protection against loss, theft, or damage in transit.';

const SMARTCART_ROOT_SELECTOR = '#rebuy-cart';
const ADDON_TITLE_SELECTOR = '#sca-cart-addon .product-title-sca';

let observedRoot = null;
let pendingTitleFrame = null;

function applyAddonTitle() {
  // Vue swaps the node itself, not just its text, so re-query every pass.
  document.querySelectorAll(ADDON_TITLE_SELECTOR).forEach((element) => {
    if (element.textContent.trim() === title) return;
    element.textContent = title;
  });
}

const smartcartObserver = new MutationObserver(() => {
  if (pendingTitleFrame !== null) return;

  pendingTitleFrame = requestAnimationFrame(() => {
    pendingTitleFrame = null;
    observeSmartcart();
    applyAddonTitle();
  });
});

function observeSmartcart() {
  // Watch the body until SmartCart mounts, then narrow to (and re-attach on) its root.
  const root = document.querySelector(SMARTCART_ROOT_SELECTOR) || document.body;
  if (root === observedRoot && root.isConnected) return;

  observedRoot = root;
  smartcartObserver.disconnect();
  smartcartObserver.observe(root, { childList: true, subtree: true, characterData: true });
}

function refreshAddonTitle() {
  observeSmartcart();
  applyAddonTitle();
}

refreshAddonTitle();

document.addEventListener('rebuy.ready', refreshAddonTitle);
document.addEventListener('rebuy:smartcart.show', refreshAddonTitle);
document.addEventListener('rebuy:smartcart.hide', refreshAddonTitle);

// Safari restores pages from the back/forward cache with the observer's old root detached.
window.addEventListener('pageshow', refreshAddonTitle);

document.addEventListener('click', (event) => {
  const removeButton = event.target.closest('a[data-remove-item]');
  if (!removeButton) return;
  
  if (removeButton.dataset.removeItem !== insuranceVariantId) return;
  
  localStorage.setItem('shipping-insurance-rejected', 'true');
}, true);

document.addEventListener('rebuy:smartcart.show', (e) => {
  if (e.detail.smartcart.cart.items?.length === 0) return;

  const hasRejected = localStorage.getItem('shipping-insurance-rejected');
  if (hasRejected) return;

  if (isOpen) return;
  const shippingCheckbox = document.querySelector('#sca-cart-addon input[type="checkbox"]');
  if (!shippingCheckbox) return;

  isOpen = true;

  const closeEvent = () => {
    isOpen = false;
  };
  document.addEventListener('rebuy:smartcart.hide', closeEvent, { once: true });

  if (!shippingCheckbox.dataset.shippingInsuranceOptOutListenerBound) {
    shippingCheckbox.addEventListener('change', e => {
      if (e.target.checked === false) {
        localStorage.setItem('shipping-insurance-rejected', true);
      }
    });
    shippingCheckbox.dataset.shippingInsuranceOptOutListenerBound = 'true';
  }

  if (shippingCheckbox.checked === false) {
    shippingCheckbox.click();
  }
});
document.addEventListener('rebuy:smartcart.line-item-removed', (e) => {
  if (e.detail.item?.id == insuranceVariantId) {
    localStorage.setItem('shipping-insurance-rejected', true);
  }
});
